<template>
  <div class="container margin-2xl-top">
    <card  title="core.yes" badge-text="core.no">
      test card content
    </card>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import useMediaManager from "@/client/extensions/composition/useMediaManager";
import ChatView from "@/client/views/Chat.vue";

export default {
  name: "PlaygroundPage",
  components: {
    ChatView,
  },
  props: {},
  layout: {
    component: "default",
    params: {
      title: "justopp.hotDeals.pageTitle",
      subTitle: "justopp.hotDeals.pageSubtitle",
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let mediaManager = useMediaManager(props, {});
    return { asyncOps, asyncOpsReady, asyncStatus, mediaManager };
  },
  data: function () {
    return {

    }
  },
  computed: {
    pgForm2ComputedAction() {
      let result = "files";
      if (this.pgForm2Data.accountUUID) {
        result = result + "/" + this.pgForm2Data.accountUUID;
      }

      if (this.pgForm2Data.file) {
        result = result + "/" + this.pgForm2Data.file;
      }
      return result;
    },
  },
  watch: {},
  mounted() {
    //  throw new Error('pg error');
  },
  beforeUnmount() {},
  created() {
    //    throw new Error('pg created error');
    //   this.ss('test.testA', 'genericValue!')
    //  console.log('after setter', this.sg('test.testA', 'DEFAULT VALUE'));
  },
  methods: {
    async playground() {},
    async playgroundServer() {
      let payload = {};

      let result = await this.asyncOps.asyncCall("playground/use-case2", payload);

      console.log(result);

      if (result.isError) {
        console.log("request error", result.code, result.status.error);
      } else {
        console.log("request successful");
      }

      console.log("data", result.data);
    },
    async playgroundCustom() {
      let payload = {};
      console.log("run");

      let result = await this.asyncOps.asyncCall("use-case/list/acl", payload);

      //    let result = await this.asyncOps.asyncCall('acl/by-group', payload);

      console.log(result);

      if (result.isError) {
        console.log("request error", result.code, result.status.error);
      } else {
        console.log("request successful");
      }

      console.log("data", result.data);
    },
    pgFormSuccessHandler(result) {
      console.log("form result is success:", !!result.isError);
      console.log(result.resultData);
    },
    pgForm2SuccessHandler(result) {
      console.log("form 2 result:", !!result.isError);
      console.log(result.resultData);
    },
    async uploadFile() {
      let result;
      await this.performWithUi(async () => {
        return (result = await this.mediaManager.upload(this.files[0]));
      });
      /*
      await this.performWithUi(async () => {
        return (result = await this.mediaManager.rename(
          result.id,
          "test111.png"
        ));
      });

      const test = await this.performWithUi(async () => {
        return (result = await this.mediaManager.delete(result.id));
      });
*/
    },
  },
};
</script>

<style scoped lang="scss"></style>
